import { FC, useEffect } from "react";
import {
  Box,
  Flex,
  Image,
  Text,
  useMediaQuery,
  useToast,
} from "@chakra-ui/react";
import PaymentDrawer from "./PaymentDrawer";
import PaymentIcon from "../../../assets/payment.svg";
import CustomDrawer from "../../../components/CustomDrawer";
import { formatNumberMax } from "../../../utils/format.number";
import { mailCreditsStore } from "../../../hooks/store";
import { useSnapshot } from "valtio";
import Button from "../../../components/Button2";
import Icon from "../../../components/Icon";

type BalanceCmpProps = {
  credits: number;
};
export const BalanceCmp: FC<BalanceCmpProps> = ({ credits }) => {
  return (
    <Flex
      border={"1px solid #FFFFFF"}
      bgColor={"#E13D3D"}
      px={"5px"}
      borderRadius={"40px"}
      justifyContent={"center"}
      alignItems={"center"}
      pos={{ base: "absolute", md: "relative" }}
      top={0}
      right={0}
    >
      <Text
        fontFamily={"font4"}
        fontSize={"11px"}
        fontWeight={700}
        color={"#FFFFFF"}
      >
        {formatNumberMax(credits)}
      </Text>
    </Flex>
  );
};

const InAppCredits = () => {
  const { inAppCredits, latestCreditsPurchase, isMailCreditsDrawerOpen } = useSnapshot(mailCreditsStore);
  const [isSmallerThan425] = useMediaQuery("(max-width: 425px)");
  const [isSmallerThan900] = useMediaQuery("(max-width: 900px)");

  const toast = useToast({
    position: "top",
    containerStyle: {
      zIndex: 9,
    },
  });

  useEffect(() => {
    if (latestCreditsPurchase !== 0) {
      toast({
        status: "success",
        description:
          "credit purchase of " + latestCreditsPurchase + " successful.",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latestCreditsPurchase]);

  return (
    <Flex justify={"center"} align={"center"} fontFamily={"font4"} h={{ base: "40px", md: "46px"}}>
      {
        !isSmallerThan900 ?
          <Flex
            gap={1}
            px={"12px"}
            bgColor={"#F4FFF2"}
            alignItems={"center"}
            cursor={"pointer"}
            justifyContent={"center"}
            border={"1px solid #DFE6ED"}
            borderRadius={"25px"}
            h={{base: "32px", md: "38px"}}
            // boxShadow={"-1px 2px 19px 1px hsla(0, 0%, 50%, .192)"}
            onClick={() => {
              mailCreditsStore.isMailCreditsDrawerOpen = true;
            }}
          >
            <Box
              w={inAppCredits.balance.toString().length >= 3 ? "38px" : "32px"}
              pos={"relative"}
            >
              <Box position={"absolute"} left={2}>
                <BalanceCmp credits={inAppCredits.balance} />
              </Box>
              <Image src={PaymentIcon} w={"18px"} h={"36px"} />
            </Box>
            <Text
              fontSize={"14px"}
              color={"#4C9063"}
              textTransform={"uppercase"}
              letterSpacing={"1.1px"}
            >
              Mails
            </Text>
          </Flex>
          :
          <Button variant="secondary"
            fontFamily={"font4"}
            iconLeft={<Icon name="coin" variant="stroke" />}
            sx={{
              "--button-icon-size": "20px",
              "justifyContent": "flex-start"
            }}
            onClick={() => {
              //  open the mail drawer
              mailCreditsStore.isMailCreditsDrawerOpen = true;
            }}>
            MAILS  <BalanceCmp credits={inAppCredits.balance} />
          </Button>
      }
      <CustomDrawer
        placement={isSmallerThan425 ? "bottom" : "right"}
        isOpen={isMailCreditsDrawerOpen}
        onClose={() => {
          mailCreditsStore.isMailCreditsDrawerOpen = false;
        }}
        h={isSmallerThan425 ? "100%" : "full"}
        content={<PaymentDrawer onClose={() => {
          mailCreditsStore.isMailCreditsDrawerOpen = false;
        }} />}
        borderTopRadius={0}
      />
    </Flex>
  );
};

export default InAppCredits;
